export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7668.640fd2b4.jpg";